import AbstractVideo from "video/AbstractVideo";
import VideoHelper from "video/VideoHelper";

class VimeoVideo extends AbstractVideo {
    constructor(data, $element, settings = {}) {
        super(data, $element, settings);

        this.initialisePlayer();
    }

    play() {
        this.player.play();
    }

    pause() {
        this.player.pause();
    }

    stop() {
        this.player.unload();
    }

    seek(time) {
        this.player.setCurrentTime(time);
    }

    setVolume(volume) {
        this.player.setVolume(volume);
    }

    initialisePlayer() {
        let player = this.player = new Vimeo.Player(this.$element[0], {
            id: this.video_id,
            autoplay: this.settings.autoplay,
            byline: false
        });

        player.on("ended", () => this.emit("ended"));
        player.on("loaded", () => this.emit("loaded"));
        player.on('play', () => this.emit("play"));
        player.on('pause', () => this.emit("pause"));
    }

    destroy() {
        super.destroy();

        //There isn't really a destroy method for vimeo, the best we can do is unload and release the object
        this.stop();
        this.player = null;

        this.$element.html('');
    }
}

VideoHelper.register('2' /*Vimeo*/, VimeoVideo);

export default VimeoVideo;
